// src/services/api.js
import http from '@/http/axios';

// 根据需要动态设置baseURL
const SSO_HOST = process.env.SSO_HOST;
const TOOL_API = process.env.TOOL_API;

const getTokenByCode = (code) => {
    http.setBaseURL(SSO_HOST); // 更新baseURL
    return http.post('/v1/account/get_token_by_code', {}, { params: { code } }); // 实际的API路径
};

const getNcmjByAI = (question) => {
    http.setBaseURL(TOOL_API); // 更新baseURL
    return http.post('/tool/ai/ncmj', { question: question }); // 实际的API路径
};

const askQuestion = (question) => {
    http.setBaseURL(TOOL_API); // 更新baseURL
    return http.post('/tool/ai/ask_question', { question: question }); // 实际的API路径
};

const pageStatistics = (page_url) => {
    http.setBaseURL(TOOL_API); // 更新baseURL
    return http.post('/v1/tools/record_visit',{page_url:page_url}); // 实际的API路径
}

const generatePetPhoto = (formData) => {
    http.setBaseURL(TOOL_API);
    return http.post('/v1/tools/ai/generate', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 0  // 设置为0表示不限制超时时间
    });
};

const generateToyPhoto = (formData) => {
    http.setBaseURL(TOOL_API);
    return http.post('/v1/tools/ai/generate_toy', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 0  // 设置为0表示不限制超时时间
    });
};

const xuebiTravelDiary = (params) => {
    http.setBaseURL(TOOL_API); // 更新baseURL
    return http.get('/v1/tools/xuebi_travel_diary',params); // 实际的API路径
}

export default {
    getTokenByCode,
    getNcmjByAI,
    askQuestion,
    pageStatistics,
    generatePetPhoto,
    generateToyPhoto,
    xuebiTravelDiary,
};



// WEBPACK FOOTER //
// ./src/services/api.js